export default __webpack_public_path__ + "static/media/rules-agreement-background.d519ebd7.png";